import CountryList from '../../slices/master/country/CountryList'
import CountryDetails from "../../slices/master/country/CountryDetails"
import StateList from '../../slices/master/state/StateList'
import StateDetails from '../../slices/master/state/StateDetails'
import StatebyCountry from '../../slices/master/state/StatebyCountry'
import CityList from '../../slices/master/city/CityList'
import CityDetails from '../../slices/master/city/CityDetails'
import CitybyState from '../../slices/master/city/CitybyState'
import DepartmentList from '../../slices/master/department/DepartmentList'
import DepartmentDetails from '../../slices/master/department/DepartmentDetails'
import DesignationList from '../../slices/master/designation/DesignationList'
import DesignationDetails from '../../slices/master/designation/DesignationDetails'
import LocationList from '../../slices/master/location/LocationList'
import LocationDetails from '../../slices/master/location/LocationDetails'
import LocationByDepartment from '../../slices/master/location/LocationByDepartment'
import ComponentList from '../../slices/master/component/ComponentList'
import ComponentDetails from '../../slices/master/component/ComponentDetails'
import ComponentByLocation from '../../slices/master/component/ComponentByLocation'
import MakeList from '../../slices/master/make/MakeList'
import MakeDetails from '../../slices/master/make/MakeDetails'
import EquipmentList from '../../slices/master/equipment/EquipmentList'
import EquipmentDetails from '../../slices/master/equipment/EquipmentDetails'
import EquipmentAssignList from '../../slices/master/equipmentAssign/EquipmentAssignList'
import EquipmentAssignDetails from '../../slices/master/equipmentAssign/EquipmentAssignDetails'
import EquipmentByComponent from '../../slices/master/equipmentAssign/EquipmentByComponent'
import EquipmentByDepartment from '../../slices/master/equipmentAssign/EquipmentByDepartment'
import ObjectConditionList from '../../slices/master/objectCondition/ObjectConditionList'
import ObjectConditionDetails from '../../slices/master/objectCondition/ObjectConditionDetails'
import ObjectList from '../../slices/master/object/ObjectList'
import ObjectDetails from '../../slices/master/object/ObjectDetails'
import CheckImportStatus from '../../slices/master/object/CheckImportStatus'

const masterReducer = {
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    cityList: CityList,
    cityDetails: CityDetails,
    citybyState: CitybyState,
    departmentList: DepartmentList,
    departmentDetails: DepartmentDetails,
    designationList: DesignationList,
    designationDetails: DesignationDetails,
    locationList: LocationList,
    locationDetails: LocationDetails,
    locationByDepartment: LocationByDepartment,
    componentList: ComponentList,
    componentDetails: ComponentDetails,
    componentByLocation: ComponentByLocation,
    makeList: MakeList,
    makeDetails: MakeDetails,
    equipmentList: EquipmentList,
    equipmentDetails: EquipmentDetails,
    equipmentAssignList: EquipmentAssignList,
    equipmentAssignDetails: EquipmentAssignDetails,
    equipmentByComponent: EquipmentByComponent,
    equipmentByDepartment: EquipmentByDepartment,
    objectConditionList: ObjectConditionList,
    objectConditionDetails: ObjectConditionDetails,
    objectList: ObjectList,
    objectDetails: ObjectDetails,
    checkImportStatus: CheckImportStatus,
};

export default masterReducer;